import { Button, Card, Input, Text } from "../../../components";
import Localization from "../../../localization";
import React, { useState } from "react";
import styled from "styled-components";
import { Tools } from "../../../utils";

const Styled = styled(Card)`
  .ant-input {
    font-size: 1.6em;
    padding: 0 10px;
    font-weight: 600;
    text-align: center;
  }
`;

const InvalidLicense = ({ onDone, uuid = "" }) => {
  const [value, setValue] = useState(uuid);

  return (
    <Styled title={Localization.activate.invalid_title}>
      <Text type="secondary" children={Localization.activate.invalid_desc} />
      <Input
        maxLength="24"
        className="m-20-t"
        value={Tools.maskLicenseKey(value)}
        placeholder="XXXX XXXX XXXX XXXX XXXX"
        styles={{
          input: { fontSize: "3rem", textAlign: "center", fontWeight: "600" },
        }}
        onChange={({ target }) => {
          setValue(target.value.replace(/ /g, ""));
        }}
      />
      <Button
        type="primary"
        className="m-30-t"
        disabled={value.length !== 20}
        title={Localization.general.confirm}
        onClick={() => onDone(value.replace(/ /g, ""))}
      />
    </Styled>
  );
};

export default InvalidLicense;
